import { render, staticRenderFns } from "./ChatImageFullScreen.vue?vue&type=template&id=454d97fe&scoped=true"
import script from "./ChatImageFullScreen.vue?vue&type=script&lang=js"
export * from "./ChatImageFullScreen.vue?vue&type=script&lang=js"
import style0 from "./ChatImageFullScreen.vue?vue&type=style&index=0&id=454d97fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454d97fe",
  null
  
)

export default component.exports